import { render, staticRenderFns } from "./addDictData.vue?vue&type=template&id=5116d92e"
import script from "./addDictData.vue?vue&type=script&lang=js"
export * from "./addDictData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports